import { Component, OnInit } from '@angular/core';
import { GenericService } from 'src/app/services/generic/generic.service';

@Component({
  selector: 'app-grafica-categoria',
  templateUrl: './grafica-categoria.component.html',
  styleUrls: ['./grafica-categoria.component.css']
})
export class GraficaCategoriaComponent implements OnInit {

  title = "";
  database = "app_productos";
  public requestData: any;
  public dataLoaded: boolean = false;


    public colorsPie = [
    "#EE7733",
    "#0077BB",
    "#33BBEE",
    "#EE3377",
    "#CC3311",
    "#009988",
    "#BBBBBB",
  ];

  public optionsDataPorTipo = {
    field: "cantidad",
    label: "tipo",
  };

  public barChartOptions = {
    plugins: {
      legend: {
        display: true,
      },
    },
    scales: {
      y: {
        ticks: {
          stepSize: 1,
          precision: 0,
        },
        beginAtZero: true,
      },
    },
  };

  public pieChartOptions = {
    plugins: {
      legend: {
        display: false,
      },
    },
  };

  constructor(private genericService: GenericService) {}


  ngOnInit() {
    this.loadData();
  }

    private loadData() {
    this.genericService.getList(this.database).subscribe(
      (resp: any) => {
        const dataPorTipo = this.groupByType(resp.productos);
        this.requestData = dataPorTipo;
        console.log(this.requestData)
        this.dataLoaded = true;
      },
      (error) => {
        console.log("Error al cargar los datos", error);
      }
    );
  }

  private groupByType(data: any[]): any[] {
    const tiposMap = new Map<string, number>();

    data.forEach((row) => {
      const tipo = row.envase || "Sin tipo";
      const cantidad = tiposMap.get(tipo) || 0;
      tiposMap.set(tipo, cantidad + 1);
    });

    return Array.from(tiposMap.entries()).map(([tipo, cantidad]) => ({
      tipo,
      cantidad,
    }));
  }


}
